<template>
    <select class="form-control" id="statelist" placeholder="State" @change="handleChange">
        <option data-country="124" value="Alberta">Alberta</option>
        <option data-country="124" value="Beyond the limits of any Prov.">Beyond the limits of any Prov.</option>
        <option data-country="124" value="British Columbia">British Columbia</option>
        <option data-country="124" value="Manitoba">Manitoba</option>
        <option data-country="124" value="New Brunswick">New Brunswick</option>
        <option data-country="124" value="Newfoundland">Newfoundland</option>
        <option data-country="124" value="Northwest Territories">Northwest Territories</option>
        <option data-country="124" value="Nova Scotia">Nova Scotia</option>
        <option data-country="124" value="Ontario">Ontario</option>
        <option data-country="124" value="Prince Edward Island">Prince Edward Island</option>
        <option data-country="124" value="Quebec">Quebec</option>
        <option data-country="124" value="Saskatchewan">Saskatchewan</option>
        <option data-country="124" value="Yukon">Yukon</option>
    </select>
</template>

<script>
export default {
methods: {
    handleChange (e) {
      // Set Regus State.
      if(e.target.options.selectedIndex > -1) {
        let regusState = e.target.value;
        this.$store.commit('setRegusState', regusState);
      }
    }
  }
}
</script>

<style>

</style>
